export function FastAPIIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className}
        width="56" 
        height="56" 
        viewBox="0 0 56 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M28 2.95071e-08C12.5368 -0.000702235 0.000700326 12.534 3.2565e-07 27.9972C-0.00233301 43.4625 12.5347 56.0007 28 56C43.4653 56.0007 56.0023 43.4625 56 27.9972C55.9993 12.534 43.4632 -0.000936324 28 2.95071e-08ZM26.0657 12.6768H43.6823L25.9945 25.15H38.0877L12.3177 43.3178C16.9013 33.1047 21.4839 22.8912 26.0657 12.6768Z" 
          fill="#12988A" 
        />
      </svg>
    )
  }